import { endPoint } from "./base.config";

export const companyUsers = {
  add: `${endPoint}companyUsers`,
  fetchAll: `${endPoint}companyUsers`,
  delete: `${endPoint}companyUsers/:id`,
}

export const companyUsersReminder = {
  add: `${endPoint}companyUsersReminder`,
  update: `${endPoint}companyUsersReminder/:id`,
}

export const companyUsersAlertVoucher = {
  add: `${endPoint}companyUsersAlertVoucher`,
  update: `${endPoint}companyUsersAlertVoucher/:id`,
}

export const companyUsersAssignPayment = {
  get: `${endPoint}company-users-assign-payment`,
  add: `${endPoint}company-users-assign-payment`,
  update: `${endPoint}company-users-assign-payment/:id`,
  getBanksVerifiedPayment: `${endPoint}company-users-assign-payment/banks-verified-payment/:assignUser`,
  addEditBanksVerifiedPayment: `${endPoint}company-users-assign-payment/banks-verified-payment/:assignUser`,
  fetchAssignUserByCompany: `${endPoint}/company-users-assign-payment/fetch-assign-users-by-company`,
}